import React from "react";

export default function ReviewPageBanner() {
  return (
    <span>
      Warning : If any items are marked as errors (indicated by a ✗ icon), you
      will not be able to file your application. Confirm the completeness and
      accuracy of your application before filing.
    </span>
  );
}
